﻿<template>
	<div class="dashboard">

		<!-- ─── En-tête ─── -->
		<div class="dash-header">
			<div>
				<p class="dash-date">{{ currentDate }}</p>
				<h1 class="dash-title">Tableau de bord</h1>
			</div>
			<div class="dash-header-right">
				<v-btn icon small @click="toggleSensitive" class="mr-2">
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-icon v-bind="attrs" v-on="on" size="20" :color="hideSensitive ? '#c62828' : '#6b7280'">
								{{ hideSensitive ? 'mdi-eye-off-outline' : 'mdi-eye-outline' }}
							</v-icon>
						</template>
						<span>{{ hideSensitive ? 'Afficher les données financières' : 'Masquer les données financières' }}</span>
					</v-tooltip>
				</v-btn>
				<span class="live-badge">
					<span class="live-dot"></span>
					En direct
				</span>
			</div>
		</div>

		<!-- ─── KPI Cards ─── -->
		<v-row class="mb-2">

			<v-col cols="12" sm="12" lg="4">
				<div class="kpi-card">
					<div class="kpi-top">
						<div class="kpi-icon-box kpi-red">
							<v-icon size="22" color="white">mdi-run-fast</v-icon>
						</div>
						<span class="kpi-trend kpi-trend-up">
							<v-icon size="13" color="#00897b">mdi-arrow-up</v-icon>
							Aujourd'hui
						</span>
					</div>
					<h2 class="kpi-value">
						<span v-if="statsLoading" class="kpi-loading">—</span>
						<span v-else>{{ todayPresences }}</span>
					</h2>
					<p class="kpi-label">Présences</p>
					<div class="kpi-footer-bar kpi-bar-red"></div>
				</div>
			</v-col>

			<v-col cols="12" sm="12" lg="4">
				<div class="kpi-card">
					<div class="kpi-top">
						<div class="kpi-icon-box kpi-teal">
							<v-icon size="22" color="white">mdi-cash-minus</v-icon>
						</div>
						<span class="kpi-trend">{{ currentMonthLabel }}</span>
					</div>
					<h2 class="kpi-value">
						<span v-if="expenseStatsLoading" class="kpi-loading">—</span>
						<span v-else-if="hideSensitive" class="kpi-hidden">••••••</span>
						<span v-else>{{ (expenseStats.month || 0).toLocaleString('fr') }}</span>
					</h2>
					<p class="kpi-label">Dépenses (FCFA)</p>
					<div class="kpi-footer-bar kpi-bar-teal"></div>
				</div>
			</v-col>

			<v-col cols="12" sm="12" lg="4">
				<div class="kpi-card">
					<div class="kpi-top">
						<div class="kpi-icon-box kpi-navy">
							<v-icon size="22" color="white">mdi-playlist-check</v-icon>
						</div>
						<span class="kpi-trend">Disponibles</span>
					</div>
					<h2 class="kpi-value">
						<span v-if="statsLoading" class="kpi-loading">—</span>
						<span v-else>{{ totalSubscriptions }}</span>
					</h2>
					<p class="kpi-label">Abonnements</p>
					<div class="kpi-footer-bar kpi-bar-navy"></div>
				</div>
			</v-col>

			<!-- <v-col cols="12" sm="6" lg="3">
				<div class="kpi-card">
					<div class="kpi-top">
						<div class="kpi-icon-box kpi-teal">
							<v-icon size="22" color="white">mdi-cash-multiple</v-icon>
						</div>
						<span class="kpi-trend">Au total</span>
					</div>
					<h2 class="kpi-value">
						<span v-if="statsLoading" class="kpi-loading">—</span>
						<span v-else>{{ totalTransactions }}</span>
					</h2>
					<p class="kpi-label">Transactions</p>
					<div class="kpi-footer-bar kpi-bar-teal"></div>
				</div>
			</v-col> -->

		</v-row>

		<!-- ─── Statistiques abonnements ─── -->
		<v-card elevation="2" rounded="xl" class="mb-6 sub-stats-card">
			<div class="sub-stats-header">
				<div class="sub-stats-left">
					<div class="sub-stats-icon">
						<v-icon size="18" color="white">mdi-chart-bar</v-icon>
					</div>
					<div>
						<p class="sub-stats-title">Statistiques des abonnements</p>
						<p class="sub-stats-sub">Ventes &amp; revenus</p>
					</div>
				</div>
				<div class="period-filters">
					<v-btn-toggle v-model="statsPeriod" mandatory dense class="period-toggle">
						<v-btn value="today" small class="period-btn">Aujourd'hui</v-btn>
						<v-btn value="week" small class="period-btn">Semaine</v-btn>
						<v-btn value="month" small class="period-btn">Mois</v-btn>
						<v-btn value="year" small class="period-btn">Année</v-btn>
						<v-btn value="custom" small class="period-btn">Personnalisé</v-btn>
					</v-btn-toggle>
				</div>
			</div>

			<div v-if="statsPeriod === 'custom'" class="custom-date-row">
				<v-menu v-model="customStartMenu" :close-on-content-click="false">
					<template v-slot:activator="{ on, attrs }">
						<v-text-field
							v-model="customStartDate"
							label="Du"
							outlined dense rounded hide-details
							prepend-inner-icon="mdi-calendar"
							readonly style="max-width:160px;"
							v-bind="attrs" v-on="on"
						></v-text-field>
					</template>
					<v-date-picker locale="fr" color="#c62828" v-model="customStartDate" @input="customStartMenu = false"></v-date-picker>
				</v-menu>
				<v-menu v-model="customEndMenu" :close-on-content-click="false">
					<template v-slot:activator="{ on, attrs }">
						<v-text-field
							v-model="customEndDate"
							label="Au"
							outlined dense rounded hide-details
							prepend-inner-icon="mdi-calendar"
							readonly style="max-width:160px;"
							v-bind="attrs" v-on="on"
						></v-text-field>
					</template>
					<v-date-picker locale="fr" color="#c62828" v-model="customEndDate" @input="customEndMenu = false"></v-date-picker>
				</v-menu>
				<div v-if="subStatsLoading && statsPeriod === 'custom'" class="custom-loading">
					<v-progress-circular indeterminate size="18" width="2" color="#c62828"></v-progress-circular>
				</div>
			</div>

			<v-divider></v-divider>

			<v-row class="pa-4 ma-0">
				<v-col cols="12" sm="4">
					<div class="sub-stat-kpi">
						<div class="sub-stat-icon" style="background:#eff6ff;">
							<v-icon size="20" color="#1565c0">mdi-account-plus</v-icon>
						</div>
						<div>
							<h3 class="sub-stat-val">
								<span v-if="subStatsLoading" class="kpi-loading">—</span>
								<span v-else>{{ subStats.newClients || 0 }}</span>
							</h3>
							<p class="sub-stat-lbl">Nouveaux clients</p>
						</div>
					</div>
				</v-col>
				<v-col cols="12" sm="4">
					<div class="sub-stat-kpi">
						<div class="sub-stat-icon" style="background:#fff7ed;">
							<v-icon size="20" color="#c2410c">mdi-playlist-check</v-icon>
						</div>
						<div>
							<h3 class="sub-stat-val">
								<span v-if="subStatsLoading" class="kpi-loading">—</span>
								<span v-else>{{ subStats.sold || 0 }}</span>
							</h3>
							<p class="sub-stat-lbl">Abonnements vendus</p>
						</div>
					</div>
				</v-col>
				<v-col cols="12" sm="4">
					<div class="sub-stat-kpi">
						<div class="sub-stat-icon" style="background:#f0fdf4;">
							<v-icon size="20" color="#065f46">mdi-cash-multiple</v-icon>
						</div>
						<div>
							<h3 class="sub-stat-val">
								<span v-if="subStatsLoading" class="kpi-loading">—</span>
								<span v-else-if="hideSensitive" class="kpi-hidden">••••••</span>
								<span v-else>{{ (subStats.revenue || 0).toLocaleString('fr') }}</span>
							</h3>
							<p class="sub-stat-lbl">Chiffre d'affaires (FCFA)</p>
						</div>
					</div>
				</v-col>
			</v-row>

			<v-divider></v-divider>

			<!-- ─── Tableau des attributions ─── -->
			<div class="detail-section-header">
				<v-icon size="15" color="#6b7280" class="mr-2">mdi-format-list-bulleted</v-icon>
				<span class="detail-section-title">Détail des attributions</span>
				<v-chip x-small color="#f3f4f6" text-color="#6b7280" class="ml-2">{{ filteredSubDetails.length }}</v-chip>
				<v-spacer></v-spacer>
				<v-text-field
					v-model="detailSearch"
					prepend-inner-icon="mdi-magnify"
					placeholder="Rechercher client, type..."
					outlined dense hide-details
					style="max-width:240px;"
					color="blue darken-2"
					class="mr-4"
				></v-text-field>
			</div>

			<v-data-table
				:headers="subDetailHeaders"
				:items="filteredSubDetails"
				:loading="subStatsLoading"
				loading-text="Chargement..."
				dense
				class="detail-table"
				:items-per-page="5"
				:footer-props="{
					'items-per-page-options': [5, 10, 25, 50],
					'items-per-page-text': 'Lignes par page',
					'items-per-page-all-text': 'Tout',
				}"
				no-data-text="Aucune attribution sur cette période"
			>
				<template v-slot:[`item.customer.fullName`]="{ item }">
					<span class="detail-client">{{ item.customer && item.customer.fullName || '—' }}</span>
				</template>

				<template v-slot:[`item.subscription.label`]="{ item }">
					<div v-if="item.subscription" class="detail-sub-cell">
						<span class="detail-sub-label">{{ item.subscription.label }}</span>
						<span class="detail-sub-type">{{ item.subscription.type }} · {{ item.subscription.duration }}j</span>
					</div>
					<span v-else class="text-caption grey--text">—</span>
				</template>

				<template v-slot:[`item.subscription.price`]="{ item }">
					<span v-if="hideSensitive" class="kpi-hidden">•••</span>
					<span v-else class="detail-num">{{ (item.subscription && item.subscription.price || 0).toLocaleString('fr') }}</span>
				</template>

				<template v-slot:[`item.discount`]="{ item }">
					<span v-if="hideSensitive && item.discount" class="kpi-hidden">•••</span>
					<span v-else-if="item.discount" class="detail-discount">− {{ item.discount.toLocaleString('fr') }}</span>
					<span v-else class="text-caption grey--text">—</span>
				</template>

				<template v-slot:[`item.inscriptionFee`]="{ item }">
					<span v-if="hideSensitive && item.inscriptionFee" class="kpi-hidden">•••</span>
					<span v-else-if="item.inscriptionFee" class="detail-inscription">+ {{ item.inscriptionFee.toLocaleString('fr') }}</span>
					<span v-else class="text-caption grey--text">—</span>
				</template>

				<template v-slot:[`item.remainingAmount`]="{ item }">
					<span v-if="hideSensitive && item.remainingAmount" class="kpi-hidden">••• / •••</span>
					<div v-else-if="item.remainingAmount" class="advance-cell">
						<span class="advance-paid">
							<v-icon x-small color="#15803d">mdi-check-circle</v-icon>
							{{ item.amountPaid.toLocaleString('fr') }} versé
						</span>
						<span class="advance-remaining">
							<v-icon x-small color="#b45309">mdi-clock-outline</v-icon>
							{{ item.remainingAmount.toLocaleString('fr') }} restant
						</span>
						<v-btn x-small depressed rounded class="solder-btn" @click="openFinalize(item)">
							<v-icon x-small left>mdi-cash-check</v-icon>
							Solder
						</v-btn>
					</div>
					<span v-else class="text-caption grey--text">—</span>
				</template>

				<template v-slot:[`item.total`]="{ item }">
					<span v-if="hideSensitive" class="kpi-hidden">•••••</span>
					<span v-else class="detail-total">{{ item.total.toLocaleString('fr') }} FCFA</span>
				</template>

				<template v-slot:[`item.createdAt`]="{ item }">
					<span class="detail-date">{{ item.createdAt }}</span>
				</template>

				<template v-slot:[`item.salle`]="{ item }">
					<v-chip v-if="item.salle && item.salle.name" x-small color="#eff6ff" text-color="#1565c0">
						{{ item.salle.name }}
					</v-chip>
					<span v-else class="text-caption grey--text">—</span>
				</template>

				<template v-slot:[`footer.page-text`]="items">
					{{ items.pageStart }}-{{ items.pageStop }} sur {{ items.itemsLength }}
				</template>
			</v-data-table>
		</v-card>

		<!-- ─── Graphiques ─── -->
		<v-row class="mb-2">
			<v-col cols="12" md="8">
				<PresenceGraph />
			</v-col>
			<v-col cols="12" md="4">
				<SubscriptionClients />
			</v-col>
		</v-row>

		<!-- ─── Tableau des présences ─── -->
		<v-row>
			<v-col cols="12">
				<Presence />
			</v-col>
		</v-row>

		<!-- ─── Dialog : Solder une avance ─── -->
		<v-dialog v-model="finalizeDialog" max-width="380px" persistent>
			<v-card rounded="xl" class="pa-2">
				<div class="attr-header">
					<div class="attr-icon-box">
						<v-icon color="white" size="16">mdi-cash-check</v-icon>
					</div>
					<div>
						<p class="attr-title">Solder l'avance</p>
						<p class="attr-sub">{{ finalizeItem && (finalizeItem.customer && finalizeItem.customer.fullName || '—') }}</p>
					</div>
					<v-spacer></v-spacer>
					<v-btn icon small @click="finalizeDialog = false" :disabled="finalizeLoading">
						<v-icon color="#6b7280">mdi-close</v-icon>
					</v-btn>
				</div>
				<v-divider></v-divider>
				<v-card-text class="pt-4 pb-2">
					<p class="finalize-label">Montant restant à percevoir</p>
					<p class="finalize-amount">{{ finalizeItem ? finalizeItem.remainingAmount.toLocaleString('fr') : 0 }} FCFA</p>
					<p class="text-caption grey--text mt-1">En confirmant, le paiement de cet abonnement sera marqué comme soldé intégralement.</p>
				</v-card-text>
				<v-card-actions class="pa-4 pt-2">
					<v-btn text color="error" rounded @click="finalizeDialog = false" :disabled="finalizeLoading">Annuler</v-btn>
					<v-spacer></v-spacer>
					<v-btn depressed rounded class="attr-confirm-btn" @click="confirmFinalize" :loading="finalizeLoading">
						<v-icon left small>mdi-check</v-icon>
						Confirmer le solde
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

	</div>
</template>

<script>
import services from "@/services";
import Presence from "@/components/Admin/Dashboard/Presence.vue";
import SubscriptionClients from "@/components/Admin/Dashboard/SubscriptionClients.vue";
import PresenceGraph from "@/components/Admin/Dashboard/PresenceGraph.vue";

export default {
	components: { Presence, SubscriptionClients, PresenceGraph },

	data() {
		return {
			statsLoading: true,
			todayPresences: 0,
			totalSubscriptions: 0,
			transactions: [],
			hideSensitive: sessionStorage.getItem('hideSensitive') === 'true',
			detailSearch: "",
			// Subscription stats
			statsPeriod: "month",
			customStartDate: "",
			customEndDate: "",
			customStartMenu: false,
			customEndMenu: false,
			subStats: { newClients: 0, sold: 0, revenue: 0 },
			subStatsDetails: [],
			subStatsLoading: false,
			finalizeDialog: false,
			finalizeItem: null,
			finalizeLoading: false,
			expenseStats: { today: 0, week: 0, month: 0, year: 0 },
			expenseStatsLoading: false,
			subDetailHeaders: [
				{ text: "Client", value: "customer.fullName", sortable: false },
				{ text: "Abonnement", value: "subscription.label", sortable: false },
				{ text: "Prix", value: "subscription.price", sortable: false, align: "right" },
				{ text: "Remise", value: "discount", sortable: false, align: "right" },
				{ text: "Inscription", value: "inscriptionFee", sortable: false, align: "right" },
				{ text: "Avance", value: "remainingAmount", sortable: false },
				{ text: "Total", value: "total", sortable: false, align: "right" },
				{ text: "Date", value: "createdAt", sortable: false },
				{ text: "Salle", value: "salle", sortable: false },
			],
		};
	},

	computed: {
		filteredSubDetails() {
			if (!this.detailSearch.trim()) return this.subStatsDetails;
			const q = this.detailSearch.trim().toLowerCase();
			return this.subStatsDetails.filter(d => {
				const name = (d.customer?.fullName || '').toLowerCase();
				const type = (d.subscription?.type || '').toLowerCase();
				const label = (d.subscription?.label || '').toLowerCase();
				return name.includes(q) || type.includes(q) || label.includes(q);
			});
		},
		currentDate() {
			return new Intl.DateTimeFormat("fr-FR", {
				weekday: "long",
				year: "numeric",
				month: "long",
				day: "numeric",
			}).format(new Date());
		},
		currentMonthLabel() {
			return new Intl.DateTimeFormat("fr-FR", { month: "long" }).format(new Date());
		},
		totalTransactions() { return this.transactions.length; },
	},

	watch: {
		statsPeriod(val) {
			if (val !== "custom") this.loadSubStats();
		},
		customStartDate() {
			if (this.statsPeriod === "custom" && this.customStartDate && this.customEndDate) this.loadSubStats();
		},
		customEndDate() {
			if (this.statsPeriod === "custom" && this.customStartDate && this.customEndDate) this.loadSubStats();
		},
	},

	async created() {
		this.statsLoading = true;
		try {
			const [presences, subscriptions, transactions] = await Promise.all([
				services.getPresences(),
				services.getSubscriptions(),
				services.getTransactions(),
			]);
			this.todayPresences = presences.data.todayCount ?? 0;
			this.totalSubscriptions = subscriptions.data.totalCount ?? (subscriptions.data.subscriptions || []).length;
			this.transactions = transactions.data.transactions || transactions.data.transactions || [];
		} catch (err) {
			console.log(err);
		} finally {
			this.statsLoading = false;
		}
		this.loadSubStats();
		this.loadExpenseStats();
	},

	methods: {
		toggleSensitive() {
			this.hideSensitive = !this.hideSensitive;
			sessionStorage.setItem('hideSensitive', this.hideSensitive);
		},
		loadExpenseStats() {
			this.expenseStatsLoading = true;
			services.getExpenseStats()
				.then((r) => { this.expenseStats = r.data || {}; })
				.catch((e) => { console.log(e); })
				.finally(() => { this.expenseStatsLoading = false; });
		},
		openFinalize(item) {
			this.finalizeItem = item;
			this.finalizeDialog = true;
		},
		confirmFinalize() {
			this.finalizeLoading = true;
			services.finalizeAdvance(this.finalizeItem._id)
				.then(() => {
					// Mise à jour en place — pas besoin de recharger toute la page
					this.finalizeItem.amountPaid = (this.finalizeItem.amountPaid || 0) + (this.finalizeItem.remainingAmount || 0);
					this.finalizeItem.remainingAmount = 0;
					// Recalcul du KPI chiffre d'affaires
					this.subStats = {
						...this.subStats,
						revenue: this.subStatsDetails.reduce((sum, d) => {
							const inscriptionFee = d.registered === false ? 10000 : 0;
							const subscriptionNet = Math.max(0, (d.subscription?.price || 0) - (d.discount || 0));
							const paid = d.amountPaid != null ? d.amountPaid : subscriptionNet;
							return sum + paid + inscriptionFee;
						}, 0),
					};
					this.finalizeLoading = false;
					this.finalizeDialog = false;
				})
				.catch((e) => {
					console.log(e);
					this.finalizeLoading = false;
				});
		},
		loadSubStats() {
			this.subStatsLoading = true;
			const params = { period: this.statsPeriod };
			if (this.statsPeriod === "custom") {
				params.startDate = this.customStartDate;
				params.endDate = this.customEndDate;
			}
			services.getSubscriptionStats(params)
				.then((r) => {
					this.subStats = r.data || {};
					this.subStatsDetails = r.data?.details || [];
					this.subStatsLoading = false;
				})
				.catch((e) => { console.log(e); this.subStatsLoading = false; });
		},
	},
};
</script>

<style scoped>
.dashboard { font-family: Montserrat, sans-serif; padding: 8px 0 24px; }

/* ─── En-tête ─── */
.dash-header { display: flex; align-items: flex-start; justify-content: space-between; margin-bottom: 28px; }
.dash-date { font-size: 0.72rem; font-weight: 600; color: #9ca3af; letter-spacing: 0.8px; text-transform: uppercase; margin: 0 0 4px; }
.dash-title { font-size: 1.7rem; font-weight: 800; color: #111827; letter-spacing: 0.3px; margin: 0; }
.live-badge { display: inline-flex; align-items: center; gap: 7px; background: #f0fdf4; border: 1px solid #bbf7d0; color: #166534; font-size: 0.72rem; font-weight: 700; letter-spacing: 0.5px; padding: 6px 14px; border-radius: 50px; margin-top: 8px; }
.live-dot { width: 7px; height: 7px; border-radius: 50%; background: #22c55e; animation: pulse-dot 1.8s ease-in-out infinite; display: inline-block; }
@keyframes pulse-dot { 0%, 100% { opacity: 1; transform: scale(1); } 50% { opacity: 0.5; transform: scale(0.75); } }

/* ─── KPI Cards ─── */
.kpi-card { background: #ffffff; border-radius: 16px; padding: 20px 22px 0; box-shadow: 0 2px 14px rgba(0,0,0,0.06); overflow: hidden; height: 100%; display: flex; flex-direction: column; }
.kpi-top { display: flex; align-items: center; justify-content: space-between; margin-bottom: 14px; }
.kpi-icon-box { width: 44px; height: 44px; border-radius: 12px; display: flex; align-items: center; justify-content: center; }
.kpi-red  { background: #c62828; }
.kpi-blue { background: #1565c0; }
.kpi-navy { background: #1a1a2e; }
.kpi-teal { background: #00695c; }
.kpi-trend { font-size: 0.68rem; font-weight: 600; color: #9ca3af; letter-spacing: 0.5px; }
.kpi-trend-up { color: #00897b; }
.kpi-value { font-size: 2.2rem; font-weight: 800; color: #111827; letter-spacing: -1px; margin: 0 0 4px; line-height: 1; flex: 1; }
.kpi-loading { color: #d1d5db; }
.kpi-label { font-size: 0.75rem; font-weight: 600; color: #9ca3af; text-transform: uppercase; letter-spacing: 0.6px; margin: 0 0 14px; }
.kpi-footer-bar { height: 4px; border-radius: 0; margin: 0 -22px; }
.kpi-bar-red  { background: #c62828; }
.kpi-bar-blue { background: #1565c0; }
.kpi-bar-navy { background: #1a1a2e; }
.kpi-bar-teal { background: #00695c; }

/* ─── Subscription stats ─── */
.sub-stats-card { margin-top: 24px; }
.sub-stats-header { display: flex; align-items: center; justify-content: space-between; padding: 18px 20px 14px; flex-wrap: wrap; gap: 12px; }
.sub-stats-left { display: flex; align-items: center; gap: 14px; }
.sub-stats-icon { width: 38px; height: 38px; border-radius: 10px; background: linear-gradient(135deg, #c62828, #1565c0); display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
.sub-stats-title { font-size: 0.92rem; font-weight: 700; color: #111827; margin: 0 0 2px; }
.sub-stats-sub { font-size: 0.72rem; color: #9ca3af; margin: 0; }
.period-filters { display: flex; align-items: center; }
.period-toggle .period-btn { font-family: Montserrat, sans-serif; font-size: 0.75rem; font-weight: 600; text-transform: none; letter-spacing: 0; padding: 0 14px; }
.custom-date-row { display: flex; align-items: center; gap: 10px; padding: 10px 20px; flex-wrap: wrap; }
.custom-loading { display: flex; align-items: center; margin-left: 4px; }
.sub-stat-kpi { display: flex; align-items: center; gap: 14px; padding: 8px 0; }
.sub-stat-icon { width: 44px; height: 44px; border-radius: 12px; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
.sub-stat-val { font-size: 1.8rem; font-weight: 800; color: #111827; margin: 0 0 2px; letter-spacing: -0.5px; }
.sub-stat-lbl { font-size: 0.72rem; font-weight: 600; color: #9ca3af; text-transform: uppercase; letter-spacing: 0.5px; margin: 0; }

/* ─── Détail attributions ─── */
.kpi-hidden { color: #9ca3af; letter-spacing: 2px; font-weight: 700; }
.detail-section-header { display: flex; align-items: center; padding: 12px 20px 10px; gap: 8px; flex-wrap: wrap; }
.detail-section-title { font-size: 0.82rem; font-weight: 700; color: #374151; font-family: Montserrat, sans-serif; }
.detail-table { font-family: Montserrat, sans-serif; font-size: 0.8rem; }
.detail-client { font-weight: 600; color: #111827; font-size: 0.8rem; }
.detail-sub-cell { display: flex; flex-direction: column; gap: 1px; }
.detail-sub-label { font-weight: 600; color: #111827; font-size: 0.8rem; }
.detail-sub-type { font-size: 0.68rem; color: #9ca3af; }
.detail-num { font-size: 0.8rem; color: #374151; font-weight: 500; }
.detail-discount { font-size: 0.8rem; color: #c62828; font-weight: 500; }
.detail-inscription { font-size: 0.8rem; color: #1565c0; font-weight: 500; }
.advance-cell { display: flex; flex-direction: column; gap: 2px; }
.advance-paid { font-size: 0.72rem; font-weight: 600; color: #15803d; display: flex; align-items: center; gap: 3px; white-space: nowrap; }
.advance-remaining { font-size: 0.72rem; font-weight: 600; color: #b45309; display: flex; align-items: center; gap: 3px; white-space: nowrap; }
.solder-btn { background: #f0fdf4 !important; color: #065f46 !important; font-size: 0.65rem !important; font-weight: 700 !important; font-family: Montserrat, sans-serif; margin-top: 2px; }
.attr-header { display: flex; align-items: center; gap: 12px; padding: 16px 18px 12px; }
.attr-icon-box { width: 34px; height: 34px; border-radius: 8px; background: #1565c0; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
.attr-title { font-size: 0.88rem; font-weight: 700; color: #111827; margin: 0 0 2px; font-family: Montserrat, sans-serif; }
.attr-sub { font-size: 0.72rem; color: #9ca3af; margin: 0; font-family: Montserrat, sans-serif; }
.attr-confirm-btn { background: #1565c0 !important; color: white !important; font-family: Montserrat, sans-serif; font-weight: 700; font-size: 0.82rem; }
.finalize-label { font-size: 0.78rem; color: #6b7280; margin: 0 0 4px; font-family: Montserrat, sans-serif; }
.finalize-amount { font-size: 1.4rem; font-weight: 800; color: #111827; margin: 0; font-family: Montserrat, sans-serif; }
.detail-total { font-weight: 700; color: #111827; font-size: 0.82rem; white-space: nowrap; }
.detail-date { font-size: 0.75rem; color: #6b7280; white-space: nowrap; }
.detail-new-chip { font-family: Montserrat, sans-serif !important; font-size: 0.68rem !important; font-weight: 600 !important; }
</style>

